@if (isLoadingEstimate && !!errorDetected) {
<app-loader class="centerLoader pt-5"></app-loader>
}

@if (!isLoadingEstimate && errorDetected) {
<app-error-message [errorMsg]="errorText"></app-error-message>
}

@if (canShowEstimative) {
<div class="container mb-5" #result>
  <div #part1>
    <div class="top">
      <div style="width: 100%;">
        <div class="date-state">
          <h6 class="mr-1">{{estimate?.lastModifiedDate}}</h6>
          @if (estimate) {
          <h5>
            <span class="warning-state state-background" [ngClass]="{  
                                        'green-class': estimate?.state === estimationState.CERTIFIED || estimate?.state === estimationState.APPROVED,
                                        'yellow-class': estimate?.state === estimationState.INCOMPLETE ,
                                        'red-class': estimate?.state === estimationState.TO_FIX ,
                                        'dark-green-class': estimate?.state === estimationState.CLOSED,
                                        'dark-red-class': estimate?.state === estimationState.REJECTED,
                                        'blue-class': estimate?.state === estimationState.COMPLETE
                                      }">
              {{getStateText(estimate?.state)}}
              @if (estimate?.state ==estimationState.COMPLETE && estimate?.reviews?.length! > 0) {
              <a class="warning-reviews" (click)="goToReviews('reviews')"><span class="warning-icon"
                  matTooltip="{{variables.estimateNeedsReview}}" matTooltipPosition="right">
                  <mat-icon>warning</mat-icon> </span></a>
              }
            </span>
          </h5>
          }
        </div>
        @if (summaryDTO && summaryDTO?.result.criticality > 0) {
        <h5>{{variables.levelCriticality}}:
          <span class="orange-class">
            {{summaryDTO?.result.criticality < 0.3 ? variables.low1 : summaryDTO?.result.criticality>= 0.3 &&
              summaryDTO?.result.criticality < 0.5 ? variables.medium1 : summaryDTO?.result.criticality>= 0.5 &&
                summaryDTO?.result.criticality < 0.7 ? variables.high1 : variables.critic }} </span>
        </h5>
        }
        @if (showSliderDisclaimer && this.estimate.profileSnapshots.length) {
        <div style="margin-top: 8px; color: #b26a00; font-size: 12px;">
          {{variables.sliderProfilesModifiedDisclaimer}}
        </div>
        }
        @if (editMode && this.estimate.profileSnapshots.length && estimate.answers == null) {
        <div class="slider-container" style="display: flex; justify-content: flex-end;">
          <div class="dataRange">
            <h6>{{variables.sliderText}}</h6>
            <mat-slider min="0" max="{{maxSliderValue}}" step="1" [discrete]="true" [showTickMarks]="true"
              thumbLabel
              [displayWith]="formatLabel.bind(this)">
              <input matSliderThumb [(ngModel)]="sliderValue" (valueChange)="updateProfileAverage($event)">
            </mat-slider>
            <div class="labels">
              @for (item of sliderValues; track item) {
              <div class="label-container"
                [matTooltip]="formatLabel(item.value)" matTooltipPosition="below">
                <label>{{ item.value }}</label>
              </div>
              }
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  <hr>
  <div class="estimate-result mt-5" id="result">
    <div class="estimate-result-total" #part6>
      <mat-table [dataSource]="totalDataSource" multiTemplateDataRows class="mat-elevation-z8 mat-table-result mat-table-custom mt-3">
        <ng-container matColumnDef="name">
          <th class="flex-basis-l th-custom text-size" *matHeaderCellDef>
            <div class="summary-cell">
              <span>{{variables.result}}</span>
              @if (hasExpandableRows()) {
              <button mat-icon-button class="custom-button" (click)="toggleAllDetailTables()">
                <mat-icon>{{areAllDetailTablesExpanded() ? 'expand_less' : 'expand_more'}}</mat-icon>
              </button>
              }
            </div>
          </th>
          <td class="flex-basis-l td-custom" *matCellDef="let element">
            <div class="summary-cell">
              <span
                [matTooltip]="element?.id === 8 ? variables.riskRowTooltip : element?.id === 4 ? variables.macroRowTooltip : ''"
                [matTooltipDisabled]="![4, 8].includes(element?.id)"
                matTooltipPosition="right">{{element.name}}</span>
              @if (checkButton(element.name)) {
              <button mat-icon-button class="custom-button" (click)="toggleDivVisibility(element.id)">
                <mat-icon>{{isParentRowExpanded(element) ? 'expand_less' : 'expand_more'}}</mat-icon>
              </button>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" class="expanded-detail-cell">
            @if (isParentRowExpanded(element)) {
            <div class="detail-panel">

                    @if (hasCosts) {
                      <div class="detail-flex-row detail-flex-header">
                                    @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                                    <div class="detail-col-header"
                                        [class.detail-col-first]="$index === 0"
                                        [class.flex-15]="$index > 0"
                                        [class.text-end]="$index > 3 && $index != 6"
                                        [style.flex-basis]="$index == 6? '20%':null"
                                        [style.padding-left]="$index === 6? '8rem': $index < 6? '0.5rem': null"
                                        [class.dummy-cell]="column === 'dummy'">
                                      {{getExpandedHeader(element, column)}}
                                    </div>
                                    }
                      </div>
                      @for (detail of getExpandedRows(element); track $index) {
                        <div class="detail-flex-row">
                          @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                          <div class="detail-col-cell"
                              [class.detail-col-first]="$index === 0"
                              [class.flex-15]="$index > 0"
                              [class.text-end]="$index > 3 && $index != 6"
                              [style.flex-basis]="$index == 6 && !editMode? '20%':$index == 6 && editMode? '25%':null"
                              [style.padding-left]="$index === 6 && !editMode? '8rem': $index < 6? '0.5rem': null"
                              [style.text-align]="$index === 6 && editMode?'center':null"
                              [class.dummy-cell]="column === 'dummy'">
                            @if (shouldShowProfileSelector(column, detail)) {
                            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="detail-profile-select">
                              <mat-select [value]="detail.profileId || null" (selectionChange)="onProfileSelectionChange(detail, $event.value)" (openedChange)="onProfileSelectOpenedChange($event)" panelClass="profile-select-panel">
                                <mat-option>
                                  <ngx-mat-select-search
                                    [(ngModel)]="profileSearchTerm"
                                    [ngModelOptions]="{standalone: true}"
                                    [placeholderLabel]="variables.search"
                                    [noEntriesFoundLabel]="variables.noProfileFound || variables.noProjectFound || variables.noActionFound || 'No results'">
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option [value]="null">{{variables.noProfile || variables.notApplic}}</mat-option>
                                @for (profile of getFilteredAvailableProfiles(); track profile.id) {
                                <mat-option matTooltip="{{profile.center}}-{{profile.name}} {{profile.costPerHour}}"
                                  [value]="profile.id">{{profile.name}} {{profile.costPerHour}}</mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            } @else {
                            @if (column === 'profile') {
                            <span [matTooltip]="getProfileInfoTooltip(detail.profileId)" matTooltipPosition="above">
                              {{getExpandedCellValue(element, column, detail)}}
                            </span>
                            } @else {
                            {{getExpandedCellValue(element, column, detail)}}
                            }
                            }
                          </div>
                          }
                        </div>
                      }
                    }
                    @else {
                      <div class="detail-flex-row detail-flex-header">
                                    @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                                    <div class="detail-col-header"
                                        [class.detail-col-first]="$index === 0"
                                        [class.flex-15]="$index > 0"
                                        [class.text-end]="$index > 3 && $index != 6"
                                        [style.flex-basis]="$index == 6? '20%':null"
                                        [style.padding-left]="$index === 6? '8rem': $index < 6? '0.5rem': null"
                                        [class.dummy-cell]="column === 'dummy'">
                                      {{getExpandedHeader(element, column)}}
                                    </div>
                                    }
                      </div>
                      @for (detail of getExpandedRows(element); track $index) {
                        <div class="detail-flex-row">
                          @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                          <div class="detail-col-cell"
                              [class.detail-col-first]="$index === 0"
                              [class.flex-15]="$index > 0"
                              [class.text-end]="$index > 3 && $index != 6"
                              [style.flex-basis]="$index == 6? '20%':null"
                              [style.text-align]="$index === 5? 'center':null"
                              [style.padding-left]="$index === 6? '8rem': $index < 6? '0.5rem': null"
                              [class.dummy-cell]="column === 'dummy'">
                            {{getExpandedCellValue(element, column, detail)}}
                          </div>
                          }
                        </div>
                      }
                    }

            </div>
            }
          </td>
        </ng-container>
      @if (!hasCosts) {
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      }
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="effort">
        <th class="flex-15  text-end th-custom text-size" [ngStyle]="{'margin-right': hasCosts ? 'auto' : null}" *matHeaderCellDef> {{variables.effort}} ({{variables.hours}})
        </th>
        <td class="flex-15  text-end td-custom" [ngStyle]="{'margin-right': hasCosts ? 'auto' : null}" *matCellDef="let element">
          {{element.name === this.variables.prodTools ? '-'+element.effort :  element.effort}}
        </td>
      </ng-container>
      @if (hasCosts) {
        <ng-container matColumnDef="profile">
          <th class="flex-20 th-custom text-size" style="padding-left: 8rem !important" *matHeaderCellDef> {{variables.profile}} {{variables.eurosPerHour}}</th>
          <td class="flex-20 td-custom" style="padding-left: 8rem !important" *matCellDef="let element">
           {{element.name === this.variables.riskOfProject ? variables.lowest +' '+ element.profile : variables.average +' '+ element.profile}}
          </td>
        </ng-container>
        <ng-container matColumnDef="cost">
          <th class="flex-15 text-end th-custom text-size" style="margin-right:auto" *matHeaderCellDef> {{variables.cost}} </th>
          <td class="flex-15 text-end td-custom" style="margin-right:auto" *matCellDef="let element">
            {{element.name === this.variables.prodTools ? '-'+element.cost :  element.cost}}
          </td>
        </ng-container>
      }
    <mat-header-row class="mat-header-row"
      *matHeaderRowDef="hasCosts ? totalDisplayedColumnsWithCost : totalDisplayedColumns"></mat-header-row>
    <mat-row class="mat-row-drop"
      *matRowDef="let row; columns: hasCosts ? totalDisplayedColumnsWithCost : totalDisplayedColumns;"
      [ngClass]="{ genericTotalRow: row?.id === 9, genericSubTotalRow: row?.id === 7, parentRowExpanded: isParentRowExpanded(row), parentColumnRow: [1, 2, 3, 4, 5, 6, 8].includes(row?.id) }"></mat-row>
    <mat-row *matRowDef="let row; columns: expandedDetailColumns;" class="detail-row"></mat-row>
    </mat-table>
  </div>
  <div class="estimate-result-export mt-3">
    
    @if (canShowAddCommentButton && !editMode) {
    <app-button *hasPermission="Permission.ESTIMATE_REVIEW" [showWhen]="estimate?.state == estimationState.COMPLETE"
      typeBtn="secondary" style="display: flex; position: relative;" (click)="addComment()"
      message="{{variables.comment}}" mat-icon-button [matTooltip]="variables.addComment" icon="add_comment"
      iconPosition='left' iconColor="red" width='200px'>
    </app-button>
    }

    @if (!editMode) {
      <app-button *hasPermission="Permission.ESTIMATE_CERTIFY" [showWhen]="estimate?.state ==estimationState.COMPLETE"
        typeBtn="secondary" style="display: flex; position: relative;" (click)="acceptEstimate()"
        message="{{variables.certify}}" mat-icon-button [matTooltip]="variables.certifyEstimate" icon="approval"
        iconPosition='left' width='200px'>
      </app-button>

      <app-button *hasPermission="Permission.ESTIMATE_CLOSE" [showWhen]="estimate?.state ==estimationState.APPROVED"
        typeBtn="secondary" style="display: flex; position: relative;" (click)="closeEstimate()"
        message="{{variables.close}}" mat-icon-button [matTooltip]="variables.closeEstimate" icon="package_2"
        iconPosition='left' width='200px'>
      </app-button>
    }

    @if (estimate.edit && estimate?.state == estimationState.COMPLETE && !editMode) {
    <app-button typeBtn="secondary" style="display: flex; position: relative;" [class.disabled-btn]="!isOwner"
      (click)="updateEstimate()" message="{{variables.edit}}" mat-icon-button
      [matTooltip]="isOwner ? variables.editEstimate : message" icon="edit" iconPosition='left' width='200px'>
    </app-button>
    }

    @if (estimate.edit && estimate?.state == estimationState.COMPLETE && hasCosts  && !editMode) {
      <app-button typeBtn="secondary" style="display: flex; position: relative;" [class.disabled-btn]="!isOwner"
        (click)="toggleProfileEditMode()" [message]="editMode ? variables.exitProfile : variables.editProfile" mat-icon-button
        [matTooltip]="isOwner ? (editMode ? variables.exitProfile : variables.editProfile) : message"
        [icon]="editMode ? 'visibility_off' : 'manage_accounts'" iconPosition='left' width='200px'>
      </app-button>
    }

    @if (editMode) {
      <app-button typeBtn="secondary" style="display: flex; position: relative;" (click)="saveChanges()"
        message="{{variables.save}}" mat-icon-button [matTooltip]="variables.save" icon="save" iconPosition='left'
        width='200px'>
      </app-button>

      <app-button typeBtn="secondary" style="display: flex; position: relative;" (click)="resetServices()"
        message="{{variables.redefine}}" mat-icon-button [matTooltip]="variables.redefine" icon="restart_alt"
        iconPosition='left' width='200px'>
      </app-button>

      <app-button typeBtn="secondary" style="display: flex; position: relative;" (click)="cancelServices()"
        message="{{variables.cancel}}" mat-icon-button [matTooltip]="variables.cancel" icon="close"
        iconPosition='left' width='200px'>
      </app-button>
    }
    @else
    {
      <app-button [showWhen]="estimate?.state == estimationState.CERTIFIED" *hasPermission="Permission.ESTIMATE_APPROVE"
        typeBtn="secondary" style="display: flex; position: relative;" (click)="approveEstimate()"
        message="{{variables.approve}}" mat-icon-button matTooltip="{{variables.approve}}" icon="thumb_up"
        iconPosition='left' [addIconClasses]="false" width='200px'>
      </app-button>

      <app-button [showWhen]="estimate?.state == estimationState.CERTIFIED" *hasPermission="Permission.ESTIMATE_REJECT"
        typeBtn="secondary" style="display: flex; position: relative;" (click)="rejectEstimate()"
        message="{{variables.reject}}" mat-icon-button matTooltip="{{variables.reject}}" icon="thumb_down"
        iconPosition='left' [addIconClasses]="false" width='200px'>
      </app-button>

      <app-button [showWhen]="estimate?.state == estimationState.CERTIFIED" *hasPermission="Permission.ESTIMATE_TO_FIX"
        typeBtn="secondary" style="display: flex; position: relative;" (click)="toFixEstimate()"
        message="{{variables.toFix}}" mat-icon-button matTooltip="{{variables.toFix}}" icon="build" iconPosition='left'
        [addIconClasses]="false" width='200px'>
      </app-button>


      <app-button typeBtn="secondary" style="display: flex; position: relative;" (click)="exportExcel()"
        message="{{variables.exportExcel}}" mat-icon-button matTooltip="{{variables.exportExcel}}"
        icon="../../../../../assets/images/excel.svg" iconPosition='left' [addIconClasses]="false" width='200px'>
      </app-button>

      <!-- HIDDEN: Export to Jira button - to be enabled in the future -->
      <!-- @if (isAgileAndCertified) {
        <app-button typeBtn="secondary" style="display: flex; position: relative;" (click)="exportExcelToJira()"
          message="{{variables.exportToJira}}" mat-icon-button matTooltip="{{variables.exportToJira}}"
          icon="../../../../../assets/images/Jira_icon.svg" iconPosition='left' [addIconClasses]="false" width='200px'>
        </app-button>
      } -->
    }
  </div>
</div>
<br>
@if (estimate && estimate?.reviews?.length! > 0) {
<div>
  <hr><br>
  <div class="comments-container">
    <h4>{{variables.commentAndState}}</h4>
    <br>
    <ul id="comments-list" class="comments-list">
      @for (review of estimate?.reviews; track review) {
      <li>
        @if (!review?.stateChanged) {
        <div class="comment-main-level">
          <div class="comment-avatar">
            <mat-icon svgIcon="User" style="width:25px; height:25px;"></mat-icon>
          </div>
          <div class="comment-box">
            <div class="comment-head">
              <h6 class="comment-name">{{review?.architect}}</h6>
              <span>{{review?.reviewDate}}</span>
            </div>
            <div class="comment-content">
              {{review?.comment}}
            </div>
          </div>
        </div>
        }
        @if (review?.stateChanged) {
        <div class="comment-main-level">
          <div class="comment-avatar">
            <mat-icon svgIcon="User" style="width:25px; height:25px;"></mat-icon>
          </div>
          <div class="comment-box">
            <div class="comment-head">
              <span class="comment-name by-author">{{review?.architect}}</span>
              @if (review?.role) {
              <span class="role-badge">{{review?.role}}</span>
              }
              @if (review?.newState) {
              <span class="changed-state">{{getStateActionText(review?.newState)}}.</span>
              } @else {
              <span class="changed-state">{{variables.hasValidatedEstimate}}.</span>
              }
              <span>{{review?.reviewDate}}</span>
            </div>
            @if (review?.comment?.length! > 0) {
            <div class="comment-content">
              {{review?.comment}}
            </div>
            }
          </div>
        </div>
        }
      </li>
      }
    </ul>
  </div>
</div>
}
@if (estimate && estimate?.noToolsJustification && !(estimate?.noToolsJustification! == '')) {
<div>
  <br>
  <hr><br>
  <h4>{{variables.noToolsJustification}}</h4>
  <br>
  <div class="justification">
    <div>
      <div class="comment-item-justification">
        <div class="justification-top">
          <div class="comment-avatar-justification">
            <mat-icon svgIcon="User" style="width:25px; height:25px;"></mat-icon>
          </div>
          <span class="folder-span" for="label"><strong>{{estimate?.createdBy?.name}}</strong></span>
        </div>
        <p class="comment-justification ps">{{estimate?.noToolsJustification}}</p>
      </div>
    </div>
  </div>
</div>
}
</div>
}